import * as React from 'react';

import { cn } from '@codes/ui-kit/utils';
import { type VariantProps, cva } from 'class-variance-authority';

const badgeVariants = cva(
    'border-transparent shrink-0 inline-flex items-center justify-center rounded-full border px-2 py-1 text-[10px] whitespace-nowrap font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                A: 'bg-badge text-badge-text uppercase',
                B: 'text-white bg-secondary uppercase',
                C: 'h-[26px] rounded-full py-1 px-[11px] text-white capitalize border-[0.6px] text-sm font-medium shadow-[0px_0px_4px_0px_rgba(0,0,0,0.12)]',
                default: 'bg-badge text-badge-text uppercase',
                secondary: 'bg-[#F4F5F5] text-xs',
                success: 'bg-[#D4E3FF] text-[#00379F] text-xs',
                warning: 'bg-[#FEF8C9] text-[#6D570A] text-xs',
                destructive: 'bg-[#FFE4DF] text-[#CE1A00] text-xs',
                outline: 'text-foreground border border-input bg-background',
                service: 'capitalize px-3 h-[26px] text-xs font-medium',
            },
        },
        defaultVariants: {
            variant: 'A',
        },
    }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
